import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  tags: string[];
  rating: number;
  views: number;
  chapters: number;
  status: string;
}

export default function ComicCard({ id, title, author, cover, tags, rating, views, chapters, status }: ComicCardProps) {
  return (
    <Link to={`/comic/${id}`} className="group block cursor-pointer" data-product-shop>
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
        <img
          src={cover}
          alt={`${title} - 韩国漫画封面`}
          title={`${title} - 免费在线漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <div className="text-white text-xs">
            <div className="flex items-center gap-1 mb-1">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
              <span>{rating}</span>
            </div>
            <div className="flex items-center gap-1">
              <i className="ri-eye-line text-xs"></i>
              <span>{views >= 10000 ? `${(views / 10000).toFixed(1)}万` : views.toLocaleString()}</span>
            </div>
          </div>
        </div>
        {status === '已完结' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium bg-accent-500 text-white rounded-md">已完结</span>
        )}
        {status === '连载中' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium bg-primary-500 text-white rounded-md">连载中</span>
        )}
        <div className="absolute top-2 right-2 px-2 py-0.5 text-xs bg-black/60 text-white rounded-md">
          {chapters}话
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">{title}</h3>
      <p className="text-xs text-foreground-500 mb-2">{author}</p>
      <div className="flex items-center gap-1 flex-wrap">
        {tags.slice(0, 2).map(tag => (
          <span key={tag} className="px-2 py-0.5 text-xs bg-secondary-100 text-secondary-700 rounded-full">{tag}</span>
        ))}
      </div>
    </Link>
  );
}